import { useEffect, useState } from 'react'
import { PriceCoefficientAPI } from '../../../api/Argentia/endpoints/priceCoefficients/model/PriceCoefficient'
import { HttpErrorProps } from '../../../hooks'
import { ErrorCodes } from '../../../model'
import { getPriceCoefficients } from './priceCoefficientsTable.service'

interface UsePriceComponents {
  priceCoefficients: PriceCoefficientAPI[] | null
  isFetchingPriceCoefficients: boolean
  errorFetchPriceCoefficients: HttpErrorProps | null
  refreshPriceCoefficients: () => Promise<void>
}

interface UsePriceComponentsProps {
  priceID?: number
}

export default function usePriceCoefficients(
  { priceID }: UsePriceComponentsProps,
  fetchTrigger: boolean
): UsePriceComponents {
  const [isFetchingPriceCoefficients, setIsFetchingPriceCoefficients] = useState<boolean>(false)

  const [priceCoefficients, setPriceCoefficients] = useState<PriceCoefficientAPI[] | null>(null)
  const [errorFetchPriceCoefficients, setErrorFetchPriceCoefficients] =
    useState<HttpErrorProps | null>(null)

  const getCoefficients = async (priceID?: number) => {
    priceID && setPriceCoefficients((await fetchPriceCoefficients(priceID)) ?? [])
  }

  const fetchPriceCoefficients = async (
    priceID: number
  ): Promise<PriceCoefficientAPI[] | undefined> => {
    setIsFetchingPriceCoefficients(true)
    setPriceCoefficients(null)
    setErrorFetchPriceCoefficients(null)

    return await getPriceCoefficients(priceID).then(response => {
      setIsFetchingPriceCoefficients(false)
      if (response.success) {
        if (response.data !== undefined) {
          return response.data
        } else {
          return []
        }
      } else {
        response.error &&
          setErrorFetchPriceCoefficients({
            errorCode: ErrorCodes.SERVER_ERROR,
            onRefresh: async () => {
              getCoefficients(priceID)
            }
          })
        return []
      }
    })
  }

  useEffect(() => {
    // onNotificationChange(undefined)
    if (priceID && fetchTrigger) {
      getCoefficients(priceID)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [priceID, fetchTrigger])

  return {
    priceCoefficients,
    isFetchingPriceCoefficients,
    errorFetchPriceCoefficients,
    refreshPriceCoefficients: () => getCoefficients(priceID)
  }
}
